import Modal from "react-modal";
import { useMemo, useCallback, useId, useState } from "react";
import { rootElement } from ".";
import { useCarContext } from "./context";
import { useForm, Controller } from "react-hook-form";
import Select from "./Select";
import classNames from "classnames";
import send from "./send";
import { formatPhoneNumber, validatePhoneNumber } from "./phoneUtils";

const RequestInfo = () => {
  const formId = useId();
  const { selectedCar, setSelectedCar } = useCarContext();
  const [isLoading, setIsLoading] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    control,
  } = useForm();

  const isModalOpen = useMemo(() => {
    return typeof selectedCar !== "undefined";
  }, [selectedCar]);

  const closeModal = useCallback(() => {
    setSelectedCar(undefined);
    reset();
  }, [setSelectedCar, reset]);

  const onSubmit = useCallback(
    async (data) => {
      const url = window.location.href;

      const emailMatch = url.match(
        /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/
      );

      if (emailMatch) {
        const email = emailMatch[0];

        setIsLoading(true);

        await send({ ...data, ...selectedCar }, email);

        setIsLoading(false);

        closeModal();
      } else {
        console.log("Sender email not found");
      }
    },
    [selectedCar, closeModal]
  );

  return (
    <Modal
      isOpen={isModalOpen}
      onRequestClose={closeModal}
      className="modal"
      overlayClassName="overlay overlay--has-transparency-30"
      style={{
        content: {
          width: 520,
        },
      }}
      parentSelector={() => rootElement}
      closeTimeoutMS={200}
    >
      <div className="modal__header">
        <h1 className="title is-6">Request Information</h1>
      </div>
      <div className="modal__body">
        <form id={formId} onSubmit={handleSubmit(onSubmit)}>
          <div className="field">
            <div className="control is-expanded">
              <div className="select is-fullwidth">
                <Select {...register("subject")} />
              </div>
            </div>
          </div>
          <div className="field">
            <div className="control">
              <input
                className="input"
                type="text"
                placeholder="First name"
                {...register("firstName")}
              />
            </div>
          </div>
          <div className="field">
            <div className="control">
              <input
                className="input"
                type="text"
                placeholder="Last name"
                {...register("lastName")}
              />
            </div>
          </div>
          <div className="field">
            <div className="control">
              <input
                className={classNames("input", {
                  "is-danger": errors.email,
                })}
                type="email"
                placeholder="Email"
                {...register("email", { required: true })}
              />
            </div>
          </div>
          <div className="field">
            <div className="control">
              <Controller
                name="clientPhone"
                control={control}
                render={({ field: { onChange, value } }) => {
                  const isPhoneNumberValid = () => {
                    try {
                      return validatePhoneNumber(value);
                    } catch {
                      return false;
                    }
                  };

                  const formattedPhoneNumber = () => {
                    if (isPhoneNumberValid()) {
                      return formatPhoneNumber(value);
                    }
                    return value;
                  };

                  return (
                    <input
                      className="input"
                      type="text"
                      placeholder="Phone"
                      value={formattedPhoneNumber()}
                      onChange={(event) => {
                        let inputValue = event.target.value.replace(/\D/g, "");

                        if (inputValue !== "" && inputValue.charAt(0) !== "+") {
                          inputValue = "+" + inputValue;
                        }

                        if (/^\+?\d*$/.test(inputValue)) {
                          onChange(inputValue);
                        }
                      }}
                    />
                  );
                }}
              />
            </div>
          </div>
        </form>
      </div>
      <div className="modal__footer">
        <div className="field is-grouped">
          <div className="control">
            <button
              className={classNames("button is-link", {
                "is-loading": isLoading,
              })}
              type="submit"
              form={formId}
            >
              Submit
            </button>
          </div>
          <div className="control">
            <button
              className="button is-link is-light"
              type="button"
              onClick={closeModal}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default RequestInfo;
